import React from "react";
import estilo from "../styles/Paginacion.module.css";

function Paginacion({ elementosPorPagina, elementosTotales, paginacion, pag }) {
  const numeroPaginas = [];

  for (let i = 1; i <= Math.ceil(elementosTotales / elementosPorPagina); i++) {
    numeroPaginas.push(i);
  }
  return (
    <div className={estilo.botones}>
      {numeroPaginas.map((numero) => (
        <a
          href={"#" + pag + numero}
          onClick={() => paginacion(numero)}
          key={numero}
          className={estilo.boton}
        >
          {numero}
        </a>
      ))}
    </div>
  );
}

export default Paginacion;
